._scrollBtnContainer_afmla_1 {
  position: absolute;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  width: calc(100% - 48px); }

div:has(+ ._scrollBtnContainer_afmla_1) {
  margin-bottom: 78px; }
